import { useState } from 'react';
import './Button.css';

function Button() {
  const [count, setCount] = useState(0);

  const clickEvent = () => {
    setCount(count + 1);
  }
  return (
    <button className='Button' onClick={clickEvent}>count: {count}</button>
  );
}

export default Button;
